import { render, staticRenderFns } from "./RoleMembersDialog.vue?vue&type=template&id=0eb460d3&"
import script from "./RoleMembersDialog.vue?vue&type=script&lang=ts&"
export * from "./RoleMembersDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RoleMembersDialog.vue?vue&type=style&index=0&id=0eb460d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports